import { motion } from "framer-motion";
import { Truck, RotateCcw, ShieldCheck, MapPin, Mail } from "lucide-react";

export default function ShippingReturns() {
  return (
    <div data-testid="shipping-returns-page" className="pt-10 max-w-[1200px] mx-auto px-6 sm:px-12 min-h-screen pb-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="max-w-2xl mb-14"
      >
        <p className="label-track text-[#C8A165] mb-4">Policies</p>
        <h1 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0A0A0A] leading-[1.05]">
          Shipping &amp; <span className="italic text-[#C8A165]">Returns.</span>
        </h1>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-5 mb-16">
        {[
          { Icon: Truck, title: "3-Week Delivery", body: "Handcraft plus fully-insured, tracked shipping. Canada and international." },
          { Icon: RotateCcw, title: "30-Day Returns", body: "Change your mind? Return any unworn piece within 30 days for a full refund." },
          { Icon: ShieldCheck, title: "Lifetime Warranty", body: "Every Dreamonds piece is guaranteed against manufacturing defects, forever." },
        ].map(({ Icon, title, body }) => (
          <div key={title} className="bg-[#FAF7F1] border border-[#EFE7D8] p-7">
            <Icon size={22} strokeWidth={1.4} className="text-[#C8A165] mb-4" />
            <div className="font-heading text-xl text-[#0A0A0A] mb-2">{title}</div>
            <p className="text-sm text-[#525252] leading-relaxed">{body}</p>
          </div>
        ))}
      </div>

      <section className="grid md:grid-cols-2 gap-16" data-testid="shipping-details">
        <div>
          <h2 className="font-heading text-3xl text-[#0A0A0A] mb-6">Shipping</h2>
          <ul className="space-y-4 text-[#525252] leading-relaxed">
            <li><span className="text-[#0A0A0A]">Timing.</span> Total 3 weeks from order to your door. includes handcrafting, quality control, IGI-certificate issuance, and shipping.</li>
            <li><span className="text-[#0A0A0A]">Coverage.</span> Every shipment is fully insured until it reaches your hands. Signature required on delivery.</li>
            <li><span className="text-[#0A0A0A]">Canada.</span> Free carbon-neutral express shipping on all orders.</li>
            <li><span className="text-[#0A0A0A]">International.</span> Free shipping worldwide. Duties &amp; import taxes billed by the destination customs are the customer's responsibility.</li>
            <li><span className="text-[#0A0A0A]">Packaging.</span> Each piece is nested in a handfinished linen lined presentation box.</li>
            <li><span className="text-[#0A0A0A]">Certificate.</span> The IGI Certificate of Authenticity ships with your piece and is also emailed as a PDF.</li>
          </ul>
        </div>
        <div>
          <h2 className="font-heading text-3xl text-[#0A0A0A] mb-6">Returns</h2>
          <ul className="space-y-4 text-[#525252] leading-relaxed">
            <li><span className="text-[#0A0A0A]">30-day window.</span> Return any unworn piece within 30 days of delivery for a full refund to the original payment method.</li>
            <li><span className="text-[#0A0A0A]">Condition.</span> Piece must be returned in original condition, in the presentation box, with the certificate.</li>
            <li><span className="text-[#0A0A0A]">Prepaid label.</span> We provide a fully-insured prepaid return label. No restocking fee.</li>
            <li><span className="text-[#0A0A0A]">Made-to-order.</span> Custom-designed and engraved pieces are final sale unless there is a manufacturing defect.</li>
            <li><span className="text-[#0A0A0A]">Refund timing.</span> Refunds are processed within 5 business days of receipt.</li>
          </ul>
        </div>
      </section>

      <section className="mt-16 grid md:grid-cols-2 gap-10 p-10 bg-[#0A0A0A] text-white">
        <div>
          <p className="label-track text-[#C8A165] mb-3">Need help?</p>
          <h3 className="font-heading text-2xl mb-3">Our atelier team is here.</h3>
          <p className="text-white/60 text-sm">We reply within one business day, and we love answering sizing and design questions.</p>
        </div>
        <div className="space-y-3 text-sm md:text-right">
          <div className="flex md:justify-end items-center gap-3">
            <Mail size={14} className="text-[#C8A165]" />
            <a className="hover:text-[#C8A165] transition" href="mailto:atelier@dreamonds.com">atelier@dreamonds.com</a>
          </div>
          <div className="flex md:justify-end items-center gap-3">
            <MapPin size={14} className="text-[#C8A165]" />
            <span>Dreamonds Atelier, Canada</span>
          </div>
        </div>
      </section>
    </div>
  );
}
